import PauseIcon from '@mui/icons-material/Pause'
import { LicenseRow } from '@/views/Operators/Operator/Licenses/licenses.dde.table'

import { CheckboxMenuSelectedItem } from '../CheckboxMenuSelectedItem/CheckboxMenuSelectedItem'

interface CheckboxSuspendSelectedDDEOperatorLicenseItemProps<T extends LicenseRow> {
  onSuspend: (rows: T[]) => Promise<void> | void
}

export function CheckboxSuspendSelectedDDEOperatorLicenseItem<T extends LicenseRow>({
  onSuspend
}: CheckboxSuspendSelectedDDEOperatorLicenseItemProps<T>) {
  return (
    <CheckboxMenuSelectedItem
      onAction={onSuspend}
      renderItem={(row) => `${row.property} (${row.id})`}
      successMessage={(rows) => `${rows.length} licenses suspended successfully`}
      errorMessage={(rows) => `Failed to suspend ${rows.length} licenses`}
      confirmationTitle="Suspend Licenses"
      confirmationMessage="Are you sure you want to suspend the following licenses? This action cannot be undone. Already suspended licenses will not be affected by this change."
      actionLabel="Suspend"
      icon={<PauseIcon />}
    />
  )
}
